const SvgOther2 = (props) => (
  <>
    <circle cx={48} cy={48} r={48} fill={props.p40} />
  </>
);

export default SvgOther2;
